// Type for Google Maps Libraries (updated for v3.55)
export type Libraries = ('places' | 'geometry' | 'marker' | 'geocoding' | 'maps')[];

// Default libraries we're using (updated)
export const defaultLibraries = ['places', 'geometry', 'marker', 'geocoding', 'maps'] as const;

// Updated Map Library type
export interface MapsLibrary {
  Map: typeof google.maps.Map;
}

// Updated Marker Library type
export interface MarkerLibrary {
  AdvancedMarkerElement: typeof google.maps.marker.AdvancedMarkerElement;
}

// Updated Geocoding Library type
export interface GeocodingLibrary {
  Geocoder: {
    new(): google.maps.Geocoder;
  };
}

// Updated Places Library type
export interface PlacesLibrary {
  Autocomplete: typeof google.maps.places.Autocomplete;
  AutocompleteService: typeof google.maps.places.AutocompleteService;
}

// Updated helper type for loader.importLibrary results
export type LibraryImport = {
  'maps': MapsLibrary;
  'marker': MarkerLibrary;
  'places': PlacesLibrary;
  'geocoding': GeocodingLibrary;
};

// Type for Place Result (updated)
export interface PlaceResult extends google.maps.places.PlaceResult {
  formatted_address?: string;
  geometry?: {
    location: google.maps.LatLng;
    viewport?: google.maps.LatLngBounds;
  };
  address_components?: google.maps.GeocoderAddressComponent[];
  place_id?: string;
}

// Updated Autocomplete options
export interface AutocompleteOptions {
  componentRestrictions?: {
    country: string | string[];
  };
  fields?: string[];
  types?: string[];
  bounds?: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral;
  strictBounds?: boolean;
}

export const defaultFields = [
  'address_components',
  'geometry',
  'formatted_address',
  'place_id'
] as const;

export const defaultMapId = process.env.NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID!;

// Add these types back
export type AutocompleteInstance = google.maps.places.Autocomplete;

